export const tr = {
  appName: "Namaz Vakitleri",
  tabs: {
    prayer: "Namaz",
    qiblah: "Kıble",
    masjid: "Cami",
    settings: "Ayarlar",
    more: "Daha Fazla"
  },
  prayer: {
    nextPrayer: "Sonraki Namaz",
    locating: "Konumunuz belirleniyor...",
    now: "Şimdi",
    fajr: "İmsak",
    sunrise: "Güneş Doğuşu",
    dhuhr: "Öğle",
    asr: "İkindi",
    maghrib: "Akşam",
    isha: "Yatsı",
    loading: "Yükleniyor…",
    nextPrayerIn: "Sonraki namaz:",
    in: "içinde",
    today: "Bugün"
  },
  qiblah: {
    title: "Kıble Bulucu",
    subtitle: "İşaretleri hizalamak için cihazı döndürün",
    compass: "Pusula",
    direction: "Yön",
    gettingLocation: "Konum alınıyor…",
    locationPermissionRequired: "Konum izni gereklidir.",
    refresh: "Yenile"
  },
  masjid: {
    title: "Cami Bul",
    placeholder: "Adres veya şehir ara...",
    searching: "Google Haritalar'da aranıyor...",
    viewOnMaps: "Google Haritalar'da Görüntüle",
    noResults: "Yakınlarda sonuç bulunamadı.",
    local: "Yerel",
    search: "Ara"
  },
  settings: {
    title: "Ayarlar",
    location: "Konum",
    manual: "Manuel Konum",
    cityCountry: "Şehir ara...",
    latitude: "Enlem",
    longitude: "Boylam",
    calc: "Hesaplama",
    calcMethod: "Hesaplama Yöntemi",
    asrMethod: "İkindi Yöntemi",
    appearance: "Görünüm",
    lang: "Dil",
    theme: "Tema",
    system: "Sistem",
    light: "Açık",
    dark: "Koyu",
    save: "Kaydet",
    adhanEnabled: "Ezan'ı Etkinleştir",
    persistentNotifications: "Kalıcı Bildirimler",
    ishaTime: "Yatsı Vakti",
    fajrTime: "İmsak Vakti",
    ishaDefault: "Varsayılan",
    fajrDefault: "Varsayılan",
    minAfterMaghrib: "Akşam'dan Sonra Dakika",
    minBeforeSunrise: "Güneş Doğuşundan Önce Dakika",
    fixedTime: "Sabit Zaman",
    prayers: "Namazlar",
    muslimWorldLeague: "Müslüman Dünya Birliği",
    standard: "Standart"
  },
  more: {
    back: "Geri",
    tasbih: "Tesbih",
    reset: "Sıfırla",
    count: "Say",
    hijri: "Hicri Takvim",
    now: "Şimdi",
    highlights: "Ayın Öne Çıkanları",
    events: "Etkinlikler ve Haberler",
    ramadan: "RAMAZAN BAŞLANGICI",
    eid: "KURBAN BAYRAMI",
    duas: "Günlük Dualar",
    kahf: "Kehf Suresi",
    listenFull: "TÜM SURENİ DİNLE",
    pause: "DURAKLAT",
    stats: "Namaz İstatistikleri",
    statsDesc: "Günlük namaz pencereleri arasındaki zaman aralıkları",
    fajrToMaghrib: "İmsak - Akşam",
    dhuhrToAsr: "Öğle - İkindi",
    sunriseToSunset: "Güneş Doğuşu - Batışı",
    fajrToSunrise: "İmsak - Güneş Doğuşu",
    maghribToIsha: "Akşam - Yatsı",
    appInfo: "Uygulama Bilgisi",
    zakat: "Zekat Hesaplayıcı",
    zakatDesc: "Zekatınızı hesaplayın (%2.5 servet)",
    zakatTotal: "ÖDENECEK ZEKAT",
    cashSavings: "Nakit / Tasarruf",
    goldValue: "Altın Değeri",
    silverValue: "Gümüş Değeri",
    nisabNote: "Zekat ödemeden önce servetinizin Nisab eşiğini karşıladığından emin olun",
    inheritance: "Miras Hesaplayıcı",
    inheritanceDesc: "İslami miras dağılımını hesaplayın",
    estateValue: "Mülk Değeri",
    selectHeirs: "Mirasçıları Seçin",
    heirHusband: "Koca",
    heirWife: "Eş",
    heirFather: "Baba",
    heirMother: "Anne",
    heirSon: "Oğul",
    heirDaughter: "Kız",
    distribution: "DAĞILIM",
    share: "pay",
    disclaimer: "Bu basitleştirilmiş bir hesaplamadır. Karmaşık durumlar için bir alime danışın.",
    namesOfAllah: "Allah'ın 99 İsmi",
    nameNumber: "İSİM #",
    spiritualBenefit: "Manevi Fayda",
    weekDays: ["P", "P", "S", "Ç", "P", "C", "C"],
    monthly: "Aylık Vakitler",
    halalPlaces: "Helal Yerler",
    trains: "Trenler",
    less: "Daha az",
    more: "Daha fazla...",
    downloadApp: "Mobil Uygulama İndir",
    adjustHijri: "Hicri Tarihi Ayarla",
    hijriCycle: "Hicri Döngü",
    year: "Yıl",
    thisYear: "Bu Yıl",
    tenYearOverview: "10 Yıllık Genel Bakış",
    ayahs: "Ayetler",
    ayah: "AYET",
    fetchingAyahs: "Ayetler getiriliyor...",
    morning: "Sabah",
    evening: "Akşam",
    prayerStatistics: "Namaz İstatistikleri",
    prayerIntervals: "Namaz zaman aralıkları",
    daylightHours: "Gündüz saatleri",
    afternoonPeriod: "Öğleden sonra dönemi",
    fullDaylight: "Tam gün ışığı",
    dawnPeriod: "Şafak dönemi",
    eveningPeriod: "Akşam dönemi",
    errorLoading: "İstatistikler yüklenirken hata",
    loadingStats: "İstatistikler yükleniyor...",
    sons: "Oğullar",
    daughters: "Kızlar",
    searchHalal: "Helal yerler ara",
    searching: "Aranıyor...",
    noResults: "Sonuç bulunamadı",
    viewOnMaps: "Haritalarda Görüntüle",
    selectStation: "İstasyon Seç",
    favorites: "Favoriler",
    useCurrentLocation: "Mevcut Konumu Kullan",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    dataSource: "Veriler Liikennevirasto Digital API'den. Creative Commons Attribution 4.0 lisansı altında",
    appVersion: "Sürüm",
    appDescription: "Finlandiya için namaz vakitleri ve İslami araçlar"
  },
  trains: {
    useCurrentLocation: "Konumum",
    selectStation: "İstasyon Seç",
    noTrainsFound: "Tren bulunamadı",
    time: "Saat",
    track: "Peron",
    train: "Tren",
    destination: "Varış",
    cancelled: "İptal"
  },
  ramadan: {
    title: "Ramazan 2026",
    expected: "Beklenen:",
    date: "18-19 Şub",
    daysLeft: "gün kaldı",
    today: "Bugün!",
    fastingHours: "Oruç Saatleri"
  }
};
